import SolarSystem from "./solar-system";

export default SolarSystem